import { formatNumber as formatNumberDefault } from 'accounting';
export function getFormattedString(value, { emptyValue, precision, separators }, formatNumber = formatNumberDefault) {
    return typeof value === 'number' || emptyValue === 0
        ? formatNumber((typeof value === 'number' ? value : emptyValue), precision !== null && precision !== void 0 ? precision : 0, separators.thousand, separators.decimal)
        : '';
}
//# sourceMappingURL=get-formatted-string.js.map